export default __webpack_public_path__ + "static/media/ofeliafoto.166a1642.png";